var lib_core  = require("lib-core");

var TooltipModel        = require("./tooltipModel.js");
var TooltipView         = require("./tooltipView.js");
var TooltipStateMachine = require("./tooltipStateMachine.js");

var TooltipController = function(archLayers, dependencies, configuration) {
    lib_core.Controller.call(this, archLayers, dependencies, configuration);

    lib_core.GuiEvents.addEvents({
        UI_TOOLTIP_SHOW: {id: 'ui_tooltip_01', name: "UI_TOOLTIP_SHOW" },
        UI_TOOLTIP_HIDE: {id: 'ui_tooltip_02', name: "UI_TOOLTIP_HIDE" }
    });
};
lib_core.inherit(TooltipController, lib_core.Controller);

module.exports = TooltipController;

TooltipController.prototype.createStateMachine = function () {
    return new TooltipStateMachine(this.root, this.getModel());
};

TooltipController.prototype.createModel = function () {
    return new TooltipModel();
};

TooltipController.prototype.createView = function () {
    return new TooltipView(this.getModel(), this.configuration.theme);
};
